import { ParamMap } from '@angular/router';

import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { CerFormRouteOptions } from '@cer/cer-form/cer-form-route-options';

import { DocumentLibDto } from '@app/api';
import { CerRouteSetting } from '@app/app.module-generated';
import { CerFormContext } from '@cer/cer-form/cer-form-context';

import { DocumentLibFinderView } from './document-lib-finder-view';
import { DocumentLibAttachmentView } from './document-lib-attachment-view';
import { NavigationCommandMetadata } from '@cer/cer-data/cer-data-types';

export const documentLibParam = 'lib';

export class DocumentLibFinderForm extends CerFormAdapter {

  private finderParams: DocumentLibFinderParams;
  override async init(): Promise<boolean> {
    this.finderParams = new DocumentLibFinderParams(this.routeOptions, this.context);
    return this.finderParams.init();
  }

  public override viewSetInit(viewSet: CerFormViewSet) {
    const docLib = this.finderParams.docLib;
    if (docLib == null) {
      return
    }
    viewSet.title = docLib.name;
    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 60);
    const views = DocumentLibFinderViews.get(docLib, this.context);

    views.finderView.paneTarget = 'main';
    views.finderView.viewMetadata.navigations ??= [];
    views.finderView.viewMetadata.navigations.push({ link: 'nav', paneTarget: 'right', title: 'Brugere', url: 'document-lib/user', foreignKey: { entity: 'DocumentLibUser', column: 'documentLibId', parentEntity: 'linkedAttachment', parentColumn: 'documentLibId' } });
    views.attachmentView.paneTarget = 'right';
    views.attachmentView.mandatory = true,

    viewSet.viewAdd(views.finderView);
    viewSet.viewAdd(views.attachmentView, views.finderView, { parent: 'id', child: 'documentLib' });

    views.finderView.selectFolder({ name: '/', setAsRoot: true });
  }
}

export class DocumentLibFinderViews {
  public finderView: DocumentLibFinderView;
  public attachmentView: DocumentLibAttachmentView;

  public static get(docLib: DocumentLibDto, context: CerFormContext, parentView: CerFormView = null): DocumentLibFinderViews {
    const attachmentView = new DocumentLibAttachmentView(docLib, context);

    const finderView = new DocumentLibFinderView(docLib, attachmentView, parentView, context);
    finderView.viewMetadata.navigations = DocumentLibFinderViews.navigationsGet(docLib);

    attachmentView.viewMetadata.allowEdit = finderView.viewMetadata.allowEdit;
    return { finderView: finderView, attachmentView: attachmentView };
  }

  public static navigationsGet(docLib: DocumentLibDto): NavigationCommandMetadata[] {
    //if (docLib?.id == null) {
    return null;
    //}
    //return [{ link: 'navMenu', title: 'Opsætning', url: `document-lib/finder?lib={{docLib.id}}` }];
  }

}

// Helper to create a navigation for each accessable/active document lib 
export const documentFinderPath = 'document-lib/finder';

export class DocumentLibFinderFormRouteHelper {

  public static setupRoutes(routes: CerRouteSetting[], documentLibs: DocumentLibDto[]): CerRouteSetting[] {
    const template = routes.find(r => r.path == documentFinderPath);
    if (template != null) {
      /*const index = routes.indexOf(template);
      if (index > -1) {
        routes.splice(index, 1);
    }*/

      if (documentLibs?.length > 0) {
        documentLibs?.filter(docLib => docLib.indirectAccess == false)
          .forEach(docLib => {
            const route: CerRouteSetting = Object.assign({}, template);
            route.path = `${template.path}?${documentLibParam}=${docLib.id.toString()}`;
            route.routeDisabled = true;
            route.navPath = route.path;
            route.navHide = false;
            route.roles = [];
            route.title = docLib.name;
            routes.push(route);
          });
      }
      template.routeDisabled = true;
    }

    return routes;
  }
}

class DocumentLibFinderParams {

  /*this.manage(this.routeOptions.queryParamMap.subscribe(queryParam => {
  this.initFromQueryParam(queryParam)
  this.initDocLib();
  this.context.routeService.setRouteTitle(this.docLibActive.name);
}));*/

  public docLibId: number = null;
  public docLib: DocumentLibDto;

  constructor(private routeOptions: CerFormRouteOptions, private context: CerFormContext) {
  }

  public init(): boolean {
    this.onParams(this.routeOptions.queryParamMapSnapshot);
    if (this.docLib == null) {
      this.context.ui.operationEndError("Dokument bibliotek er ikke tilængeligt");
      return false;
    }
    this.context.subscriptionManager.add(
      this.routeOptions.queryParamMap.subscribe(p => this.onParams(p))
    );
    return true;
  }

  private onParams(params: ParamMap): void {
    const docLibId = this.docLibIdGet(params);
    if (docLibId != null) {
      if (docLibId != this.docLibId) {
        if (this.docLibId == null) {
          this.docLibInit(docLibId);
        }
        else {
          this.routeOptions.paramMapSnapshot = params;
          this.context.form?.recreate();
        }
      }
    }
  }

  private docLibIdGet(params: ParamMap): number {
    const docLibId = params?.get(documentLibParam);
    return docLibId != null ? Number.parseInt(docLibId) : null;
  }

  private docLibInit(docLibId: any) {
    this.docLibId = docLibId;
    if (docLibId) {
      const docLibs = this.context.session.user.documentLibs$.getValue();
      this.docLib = docLibs?.find(l => l.id == docLibId);
    }
  }
}
